/**
 *  自定义指标上报模块
 * owl 内部的 mertirc :https://docs.sankuai.com/dp/f2e/owl/master/intro/intro/#metricmanager
 */
// tslint:disable:trailing-comma

import BaseChannel from './base-channel';
import { MetricSendParams } from '../constants';
import { debug, DebugLevel } from '../../util/debug';
import { NeoNamespace } from '../../common-enum';
import { sendToNativeMetric } from './native-metric-channel';

/**
 * 自定义纬度统计模块
 */
export class MetricChannel extends BaseChannel {
  // 基础纬度
  private baseTags!: object;

  constructor() {
    super();
    this.available = 'Owl' in window;
  }

  /**
   * 设置基础纬度
   * @param data 纬度信息
   */
  setMetricTags(data: any): void {
    this.baseTags = {
      ...this.baseTags,
      ...data,
    };
  }

  send(params: MetricSendParams): void {
    const { tags } = params;
    params.tags = {
      ...this.baseTags,
      ...tags,
    };

    this.report(params);
  }

  private report(params: MetricSendParams): void {
    const { key, value, tags, isNative } = params;

    if (!key) {
      debug(
        NeoNamespace.StatMetricChannel,
        DebugLevel.Error,
        '自定义埋点的纬度信息为空'
      );
    }
    if (isNative) {
      sendToNativeMetric(key, value, tags);
      return;
    }

    // @ts-ignore
    const metricManager = window.Owl.MetricManager(window.Owl.cfgManager);
    // 增加纬度信息
    metricManager.setTags({ ...tags });
    // 设置自定义指标数据
    metricManager.setMetric(key, value);
    metricManager.report();
  }
}
